import React from "react";
import Style from "./About.module.scss";
import Terminal from "./Terminal";
import { Box } from "@mui/material";
import { info } from "../../info/Info";

export function Ls() {
  const firstName = info.firstName.toLowerCase();
  return (
    <div>
      <p>
        <span style={{ color: info.baseColor }}>
          {firstName}
          {info.lastName.toLowerCase()} $
        </span>{" "}
        cd portfolio
      </p>
      <p>
        <span style={{ color: info.baseColor }}>
          {firstName}
          {info.lastName.toLowerCase()} $
        </span>{" "}
        ls
      </p>
    </div>
  );
}

export default function About() {
  const firstName = info.firstName.toLowerCase();
  const string = ` {
      Name: "Bibhuti Swain",
      Age: 23,
      Profession: "Full Stack Developer",
      Skills: {
          Node.js,
          React.js,
          Flutter,
          React Native,
          Type Script,
          AWS,
          Firebase
          ...
      }
 }`;

  function aboutMeText() {
    return (
      <p>
        <pre>
          <code></code>
          {string}
        </pre>
      </p>
    );
  }

  return (
    <Box
      component={"main"}
      flexDirection={{ xs: "column", md: "row" }}
      alignItems={"center"}
      justifyContent={"center"}
      //   minHeight={"100vh"}
    >
      <Terminal text={Ls()} />
    </Box>
  );
}
